
import { SystemMessageTypeInfoBase } from './system-message.typeinfo.base';


export class SystemMessageTypeInfo extends SystemMessageTypeInfoBase {
}

export const SYSTEM_MESSAGE_TYPE: SystemMessageTypeInfo = new SystemMessageTypeInfo();



